var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLegend32(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 5h18v1H11zm0 8h18v-1H11zm0 7h18v-1H11zm0 7h18v-1H11zM3 12.5A2.5 2.5 0 1 1 5.5 15 2.5 2.5 0 0 1 3 12.5zm1 0A1.5 1.5 0 1 0 5.5 11 1.5 1.5 0 0 0 4 12.5zM8.154 29H2.846L5.5 23.932zm-3.656-1h2.004L5.5 26.087zM8 8H3V3h5zM7 4H4v3h3zM3 17h5v5H3zm1 4h3v-3H4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h32v32H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegend32);
export default __webpack_public_path__ + "static/media/legend-32.b787a77eaddd87d633dca08f06ed7172.svg";
export { ForwardRef as ReactComponent };